import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../Context/AuthContext/AuthContext";

export interface ProtectedRouteType {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteType> = ({ children }) => {
  const { isUserLoggedIn, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isUserLoggedIn || !user) {
      const currentPath = location.pathname + location.search;
      navigate(`/sign-in?redirect=${encodeURIComponent(currentPath)}`);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUserLoggedIn, user]);

  return <>{user || isUserLoggedIn ? children : null}</>;
};

export default ProtectedRoute;
